
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home/[query]",
      function () {
        return require("private-next-pages/home/[query].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home/[query]"])
      });
    }
  